import { propsToLink } from 'core/helpers';
import React from 'react';
import styled from 'styled-components';
import { fontNarrow } from 'styles/typography';
import { rem } from 'styles/utils';
import { Icon } from './Icon';
import { Link } from './Link';
import media from 'styles/media';
import { transitionFillHighlight } from 'styles/transitions';

const ButtonComponent = ({
  component: Component = false,
  icon = false,
  color = 'auto',
  size = 'medium',
  children,
  ...others
}) => {
  color = color || 'auto';

  return Component ? (
    <Component data-color={color} data-size={size} {...others}>
      <span>{children}</span>
      {icon && <Icon id="arrow-right" />}
    </Component>
  ) : (
    <Link data-color={color} data-size={size} {...propsToLink(others)}>
      <span>{children}</span>
      {icon && <Icon id="arrow-right" />}
    </Link>
  );
};

export const Button = styled(ButtonComponent)`
  box-sizing: border-box;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: ${rem(24)} ${rem(32)};
  border-radius: 4px;

  &[data-color='auto'] {
    background: ${({ theme }) => theme.colors.black};
    color: ${({ theme }) => theme.colors.white};
  }

  [data-background='dark'] &[data-color='auto'] {
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.black};
  }

  &[data-color='black'] {
    background: ${({ theme }) => theme.colors.black};
    color: ${({ theme }) => theme.colors.white};
  }

  &[data-color='white'] {
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.black};
  }

  &[data-color='green'] {
    background: ${({ theme }) => theme.colors.accent};
    color: ${({ theme }) => theme.colors.black};

    ${Icon} {
      color: ${({ theme }) => theme.colors.white};
    }
  }

  ${fontNarrow};
  font-weight: 600;
  font-size: ${rem(14)};
  line-height: ${16 / 14};
  text-transform: uppercase;
  letter-spacing: 0.2em;

  ${Icon} {
    display: block;
    font-size: ${rem(8)};
    color: ${({ theme }) => theme.colors.accent};
    margin-left: ${rem(16)};
    transition: inherit;
  }

  span {
    position: relative;
    z-index: 1;
    display: inline-flex;
    align-items: center;
  }

  &[data-size='small'] {
    padding: ${rem(16)} ${rem(24)};
  }

  @media (hover: hover) and (pointer: fine) {
    ${transitionFillHighlight};

    a:hover &[data-color='auto'],
    &[data-color='auto']:hover,
    a:hover &[data-color='black'],
    &[data-color='black']:hover,
    a:hover &[data-color='white'],
    &[data-color='white']:hover {
      background: ${({ theme }) => theme.colors.accent};
      color: ${({ theme }) => theme.colors.black};

      ${Icon} {
        color: ${({ theme }) => theme.colors.white};
      }
    }

    a:hover &[data-color='green'],
    &[data-color='green']:hover {
      background: ${({ theme }) => theme.colors.black};
      color: ${({ theme }) => theme.colors.white};

      ${Icon} {
        color: ${({ theme }) => theme.colors.green};
      }
    }
  }

  ${media.mobile`
    font-size: ${rem(12)};

    &[data-size='medium'] {
      padding: ${rem(16)} ${rem(24)};
    }
  `}
`;
